import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  learningJourneyData: null,
};
const learningJourneySlice = createSlice({
  name: "learningJourney",
  initialState,
  reducers: {
    setLearningJourney(state, action) {
      state.learningJourneyData = action.payload;
    },
  },
});

export const { setLearningJourney } = learningJourneySlice.actions;

export default learningJourneySlice.reducer;
